import * as React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../dialogs/Dialog';
import DropDownList from '../../forms/DropDownList';
import Sortable from "../../sortable/Sortable";
import Button from "../../buttons/Button";
import './DialogSort.scss';

const SortableItemUI = (props) => {
  const { attributes, dataItem, columns, forwardRef } = props;

  const valueRender = (element, value) => {
    if (!value) {
      return element;
    }
    const children = [
      <span key={1} className={`k-icon ${value.icon}`}></span>,
      <span key={2}>&nbsp; {element.props.children}</span>,
    ];
    return React.cloneElement(
      element,
      {
        ...element.props,
      },
      children
    );
  };

  return (
    <div
      ref={forwardRef}
      {...attributes}
      className="col-12"
    >
      <div className="k-form-field" key={dataItem.id}>
        <div className="reorder"></div>
        <DropDownList
          name={dataItem.id}
          textField="title"
          dataItemKey="field"
          data={columns}
          onChange={props.handleChange}
          value={dataItem}
        />
        <DropDownList
          name={dataItem.id}
          textField="textDir"
          dataItemKey="dir"
          data={_dirData}
          onChange={props.handleChange}
          value={dataItem}
          valueRender={valueRender}
        />
        <div>
          <Button
            onClick={() => props.removeSort(dataItem)}
            icon="close"
          />
        </div>
      </div>
    </div>
  );
};

const _initState = {
  sort: [],
  columns: [],
  allColumns: [],
  sortId: 0
}
const _dirData = [{ dir: "asc", textDir: "vzostupne", icon: "k-i-sort-asc-sm" }, { dir: "desc", textDir: "zostupne", icon: "k-i-sort-desc-sm" }];

/**
 * Sort in dialog
 * @module
 * @param {bool} isOpen - Is dialog open?
 * @param {func} handleCloseSort - Functions to close dialog
 * @param {func} handleCloseSort - Functions to confirm dialog
 * @param {array} sort - Sort
 * @param {array} schema - Schema
 */
class DialogSort extends React.Component {
  constructor(props) {
    super(props);

    this.state = _initState;
  }

  onDragOver = (event) => {
    this.setState({ sort: event.newState });
  }

  onNavigate = (event) => {
    this.setState({ sort: event.newState });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.prerareData();
    }
  }

  prerareData = () => {
    let sortId = 0;
    const allColumns = this.props.schema.map(col => (
      col.Sortable === false ? null : { field: col.field + (col.filter === "container" ? "." + col.textField : ""), title: col.title }
    ));
    let sort = this.props.sort.map(item => ({
      id: sortId++,
      ...item,
      title: allColumns.find(col => col.field === item.field).title,
      textDir: _dirData.find(el => el.dir === item.dir).textDir,
      icon: _dirData.find(el => el.dir === item.dir).icon
    }));
    const columns = allColumns.filter(col => !sort.some(el => el.field === col.field));

    if (sort.length === 0) {
      sort = [{ id: sortId++, ..._dirData[0] }]
    }

    this.setState({ sort, allColumns, columns, sortId });
  }

  handleConfirmSort = () => {
    const sort = this.state.sort.filter(item => item.field).map(({ id, title, textDir, icon, ...item }) => item);
    this.props.handleConfirmSort(sort);
  }

  removeSort = (item) => {
    const sort = this.state.sort.filter(el => el !== item);
    const columns = this.state.allColumns.filter(col => !sort.some(el => el.field === col.field))
    this.setState({ sort, columns });
  }

  handleChange = (id, value) => {
    const sort = this.state.sort.map(item => item.id === id ? { ...item, ...value } : item);
    const columns = this.state.allColumns.filter(col => !sort.some(el => el.field === col.field))
    this.setState({ sort, columns });
  }

  handleAddNewSort = () => {
    const sort = [...this.state.sort, { id: this.state.sortId, ..._dirData[0] }]
    this.setState({ sort, sortId: this.state.sortId + 1 });
  }

  render() {
    return (
      <Dialog
        isOpen={this.props.isOpen}
        onClose={this.props.handleCloseSort}
        onConfirm={this.handleConfirmSort}
        title="Zoradenie"
      >
        <div className="dialog-sort">
          <div className="k-form-inline order-wraper">
            <div className='order'>
              {this.state.sort.map((item, index) => <div>{index + 1}</div>)}
            </div>

            {this.state.sort.length > 0 &&
              <Sortable
                idField="id"
                SortableItemUI={(e) => SortableItemUI(
                  {
                    ...e,
                    handleChange: this.handleChange,
                    removeSort: this.removeSort,
                    columns: this.state.columns
                  }
                )}
                data={this.state.sort}
                onDragOver={this.onDragOver}
                onNavigate={this.onNavigate}
              />
            }

          </div>
          <div className="sort-toolbar">
            <div className="left">
              <Button
                onClick={this.handleAddNewSort}
                icon="add"
                disabled={this.state.columns.length === 0}
              />
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

DialogSort.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleCloseSort: PropTypes.func.isRequired,
  handleConfirmSort: PropTypes.func.isRequired,
  sort: PropTypes.array.isRequired,
  schema: PropTypes.array,
}

export default DialogSort;